import { combineReducers } from 'redux';

import items from './items';
import options from './options';
import itemsDeleted from './itemsDeleted';

export default combineReducers({ items, options, itemsDeleted });
